import { useCallback } from 'react';
import { useReportsStore } from './useReportsStore';
import { useFlagCreationStore, PendingFlagData } from './useFlagCreationStore';

export function useOpenFlagInPanel() {
  const setReportQueue = useReportsStore(state => state.setReportQueue);
  const setPendingFlag = useFlagCreationStore(state => state.setPendingFlag);

  const openFlagPanel = useCallback(
    (flagData: PendingFlagData) => {
      setPendingFlag(flagData);
      setReportQueue(true);
    },
    [setPendingFlag, setReportQueue]
  );

  return { openFlagPanel };
}
